export type DeviceMetricCategory = NonNullable<fhir4.DeviceMetric['category']>;
export type DeviceMetricCalibrationState = NonNullable<
  fhir4.DeviceMetricCalibration['state']
>;
export type DeviceMetricCalibrationType = NonNullable<
  fhir4.DeviceMetricCalibration['type']
>;

export enum DeviceMetricTypeCode {
  patchCalibration = 'devicemetric.calibration.patch',
}
